// extracted by mini-css-extract-plugin
export default {"root":"x6fS8"};